import styled from "@emotion/styled";
import { BaseButton } from "styles/mixin";

export const Wrapper = styled.div`
    width: 37%;
    margin: 0 22px 0 0;
    padding: 0 20px;
    border: 1px solid #ccc;

    .title {
        font-size: 1.28rem;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        font-weight: 700;
        font-style: italic;
    }

    .images {
        display: flex;
        flex-wrap: wrap;
    }

    .imgCnt {
        width: calc((100% - 76px) / 3);
        margin: 0 38px 6px 0;
        cursor: pointer;

        &:nth-of-type(3n) {
            margin-right: 0;
        }
    }
`;

export const ImageContainer = styled(BaseButton)`
    .img {
        width: 100%;
        height: auto;
    }

    .label {
        font-size: 0.85rem;
        text-transform: uppercase;
        text-align: center;
        font-weight: 700;
    }
`;
